import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from '../app/app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { LanguageRedirectService } from './services/language-redirect.service';
import {  APP_INITIALIZER} from '@angular/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
export function initLangRedirect(redirectService: LanguageRedirectService) {
  return () => redirectService.init();
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    // provideHttpClient(),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initLangRedirect,
      deps: [LanguageRedirectService],
      multi: true
    },

    importProvidersFrom(
      
      TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),

      MarkdownModule.forRoot(),

      NgCircleProgressModule.forRoot({
        backgroundColor: '#F1F1F1',
        backgroundOpacity: 0,
        backgroundPadding: -18,
        radius: 60,
        toFixed: 0,
        maxPercent: 100,
        outerStrokeWidth: 10,
        outerStrokeColor: '#FF6347',
        innerStrokeColor: '#ffffff',
        innerStrokeWidth: 1,
        showSubtitle: false,
        startFromZero: false,
      })
    ),
  ],
};
